export default {
  search(arrOfObj, keys, keyword) {
    if (!arrOfObj.length) return [];
    if (!keyword) return arrOfObj;

    return arrOfObj.filter((obj) => keys.map((key) => {
      if (!(key in obj)) return false;

      if (typeof obj[key] !== 'string' && typeof obj[key] !== 'number') {
        return false;
      }

      if (typeof obj[key] === 'number') {
        return obj[key].toString().toLowerCase().includes(keyword)
          || obj[key].toString().includes(keyword);
      }

      return obj[key].toLowerCase().includes(keyword) || obj[key].includes(keyword);
    }).reduce((acc, val) => acc || val, false));
  },
  nullify(obj) {
    const temp = { ...obj };

    Object.keys(temp).forEach((key) => {
      if (temp[key] === '') temp[key] = null;
    });

    return temp;
  },
  isTooLong(str, limit) {
    if (typeof str !== 'string') {
      return false;
    }
    return str.length >= limit;
  },
  truncate(str, limit) {
    if (typeof str !== 'string') {
      return '';
    }
    return str.length <= limit ? str : `${str.substring(0, limit)}...`;
  },
  dateToTime(date) {
    // It takes a `new Date()` instance used as datepicker's v-model
    // and return the timestamp version with hours, minutes, and seconds included
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();

    return date.setHours(hours, minutes, seconds);
  },
  strOrNum(val) {
    // Take a value and properly return it as either a string or a number
    return (isNaN(val) ? val : Number(val))
  }
};
